






























import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";
import { IFreeInputableObject, instanceOfIFreeInputableObject } from "../../objects/IFreeInputableObject";
import { DomainRegistry } from "../../../../../domain";
import { IClipboardWatchable, IClipboardItem } from "../../../../../domain/system";
import { ImageDropManager } from "../../../../dragging";
import { BrowserUtility, BrowserKinds } from "../../../../../utilities";

@Component({
  components: {
  }
})
export default class ClipboardTool extends Mixins() {
  @Prop()
  source: IDrawableItemEditable;

  @Prop({ default: true })
  isPastable: boolean;

  limitCount: number;
  items: IClipboardItem<string>[];
  selectedItemSequenceNo: number;
  watcher: IClipboardWatchable<string>;

  created(): void {
    const service = DomainRegistry.system.getClipboardService();
    const accesser = service.createAccessor();
    this.watcher = accesser.textWatcher;
    this.watcher.register(this.limitCount, this.addClipboardItems);
  }

  data(): any {
    return {
      items: [] as IClipboardItem<string>[],
      selectedItemSequenceNo: null as number,
      limitCount: 50,
    };
  }

  get isTextPastable(): boolean {
    return this.isPastable
      && (this.selectedItem != null)
      && this.isSourcePastable(this.source);
  }

  get existsItem(): boolean {
    return this.items.length > 0;
  }

  clearClipboardTextItems(): void {
    this.watcher.clear();
    this.selectedItemSequenceNo = null;
  }

  get selectedItem(): IClipboardItem<string> {
    const clipboardItem = Enumerable.from(this.items)
      .firstOrDefault(item => item.sequenceNo === this.selectedItemSequenceNo);
    return clipboardItem;
  }

  isSelectedItem(sequenceNo: number): boolean {
    return this.selectedItemSequenceNo === sequenceNo;
  }

  onDragStart(event: DragEvent, value: string): void {
    event.dataTransfer.effectAllowed = "copy";
    event.dataTransfer.setData("text", value);
  }

  paste(value: string): void {
    if (this.isSourcePastable(this.source)) {
      this.source.pasteText(value);
    }
  }

  pasteSelectedText(): void {
    const pasteItem = this.selectedItem;
    if (pasteItem == null) { return; }

    this.paste(pasteItem.value);
  }

  removeItem(item: IClipboardItem<string>): void {
    this.watcher.remove(item);
  }

  selectItem(sequenceNo: number): void {
    this.selectedItemSequenceNo = sequenceNo;
  }

  private isSourcePastable(source: any): source is IFreeInputableObject {
    return instanceOfIFreeInputableObject(source)
      && source.isFreeInputable
      && source.shouldInputFreeSelfOrAll;
  }

  private addClipboardItems(items: IClipboardItem<string>[]): void {
    // IEではDragEventのdataTransferにセットした値がクリップボードにも反映されてしまう
    // 調べた限りでは回避方法は見つからなかったので、ドラッグ中の画像情報かどうかを判定して除外している
    const filteredItems = (BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer)
      ? items.filter(i => !ImageDropManager.isImageDragParameter(i.value))
      : items;
    this.items.splice(0, this.items.length, ...filteredItems);
  }
}
